import { api } from "api/apiService";

/**
 * Завантажує список всіх категорій-пасток.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами категорій.
 */
export const fetchTrapCategories = () => {
  return api.get("/trap-category");
};

/**
 * Створює нову категорію-пастку.
 * @param {object} categoryData - Об'єкт з даними для нової категорії.
 * @returns {Promise<object>} Проміс, що повертає створений об'єкт категорії.
 */
export const createTrapCategory = (categoryData) => {
  return api.post("/trap-category", categoryData);
};

/**
 * Оновлює існуючу категорію-пастку.
 * @param {number|string} id - ID категорії для оновлення.
 * @param {object} categoryData - Об'єкт з даними для оновлення.
 * @returns {Promise<object>} Проміс, що повертає оновлений об'єкт категорії.
 */
export const updateTrapCategory = (id, categoryData) => {
  return api.put(`/trap-category/${id}`, categoryData);
};